/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Rich-text editor utilities
namespace('Slzr.RichText', function(exports, top) {
  const $ = Slzr.jQuery;

  // Watches for updates we need to care about in the editor, and updates an associated
  // input with the contents
  return exports.Editor = class Editor {
    constructor() {

      CKEDITOR.on('instanceCreated', function(evt) {
        let form;
        let {
          editor
        } = evt;
        const element = $(editor.element.$);

        // Remove title attribute from editable div
        //
        // This is a lower-priority event handler, because CKEditor sets the title
        // on all inline editors on a mode event with the default priority (10)
        editor.on('mode', function(evt) {
          ({
            editor
          } = evt);
          const editable = editor.editable();
          if (editable && editable.isInline()) { return editable.changeAttr('title', ''); }
        },
         null, null, 100);

        // Update the underlying element, and trigger change events
        editor.on('blur', function() {
          const old_val = element.val();
          const new_val = editor.getData();
          if (old_val !== new_val) {
            return element.val(new_val).trigger('change');
          }
        });

        editor.on('change', () => element.trigger('slzr:richtext:change'));

        if ((form = element.closest('form'))[0]) {
          return form.on('submit', () => element.val(editor.getData()));
        }
      });

      // Initialize RTE on textarea[data-rich-text="true"]
      $(function() {
        $('textarea[data-rich-text="inline"]').each(function() {
          const config = {};

          if ($(this).data('rich-text-toolbar')) {
            config.sharedSpaces =
              {top: $(this).data('rich-text-toolbar')};
          }
          
          // EVNT-1900: set the title of the editor to the aria-label of the textarea if it exists
          const label = $(this).attr('aria-label');
          if (label) { config.title = label; }

          const editor = CKEDITOR.inline(this, config);
          return $(this).data('ckeditor-instance', editor);
        });

        return $('textarea[data-rich-text="true"]').each(function() {
          const editor = CKEDITOR.replace(this);
          return $(this).data('ckeditor-instance', editor);
        });
      });
    }
  };
});
